import React from 'react';
import {FooterWrapper, LogoSectionWrapper, PageWrapper, RightPart} from './styles';
import {LogoSection} from '../Auth/LogoSection';
import {useResetWithCode} from '../../hooks/auth';
import {NewPasswordForm} from './NewPassword';

type ResetPasswordWithCodePropsT = {
  resetData: useResetWithCode;
};

export const ResetPasswordWithCode: React.FC<ResetPasswordWithCodePropsT> = ({resetData}) => {
  return (
    <PageWrapper>
      <LogoSectionWrapper>
        <LogoSection />
      </LogoSectionWrapper>
      <RightPart>
        <NewPasswordForm resetData={resetData} />
        <FooterWrapper />
      </RightPart>
    </PageWrapper>
  );
};
